export default __webpack_public_path__ + "static/media/Fortifying Atlantean Catalyst.be54426f.jpg";